 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account-cancellation":"account-cancellation","achievements":"achievements","ai~all-courses~alumni~bookmark~coupon~course~course-note-landing~dashboard~events~free-course~identi~bb685724":"ai~all-courses~alumni~bookmark~coupon~course~course-note-landing~dashboard~events~free-course~identi~bb685724","all-courses":"all-courses","alumni~course-cpnt~course-exercise~reader-book":"alumni~course-cpnt~course-exercise~reader-book","alumni":"alumni","events":"events","ai":"ai","bookmark":"bookmark","dashboard":"dashboard","free-course":"free-course","mini-course":"mini-course","trail-course":"trail-course","qa-question-list":"qa-question-list","coupon":"coupon","course":"course","course-note-detail~course-note-landing":"course-note-detail~course-note-landing","course-note-landing":"course-note-landing","identity":"identity","mall-order~my-order~order-detail":"mall-order~my-order~order-detail","my-order":"my-order","order-detail":"order-detail","message":"message","must-read":"must-read","points":"points","qa-question":"qa-question","referral":"referral","setting":"setting","course-cpnt":"course-cpnt","app-page":"app-page","career":"career","esg-registration":"esg-registration","activity-transcript~mall-order~plv-live-login":"activity-transcript~mall-order~plv-live-login","activity-transcript":"activity-transcript","mall-order~write-off":"mall-order~write-off","mall-order":"mall-order","plv-live-login":"plv-live-login","book~course-exercise~reader-book~training-camp":"book~course-exercise~reader-book~training-camp","course-exercise":"course-exercise","main-mode-events":"main-mode-events","Pure-Mode-book":"Pure-Mode-book","reader-book":"reader-book","book~training-camp":"book~training-camp","book":"book","training-camp":"training-camp","course-live-mode":"course-live-mode","free-book":"free-book","main-mode-favorite":"main-mode-favorite","mini-book":"mini-book","trail-book":"trail-book","course-challenge-mode":"course-challenge-mode","course-note-detail":"course-note-detail","course-video-mode":"course-video-mode","esg-order-complete":"esg-order-complete","event-redirect":"event-redirect","flash-card-detail":"flash-card-detail","flash-card-landing":"flash-card-landing","home":"home","im-team-announcement":"im-team-announcement","login":"login","login-kecuhui":"login-kecuhui","login-phone":"login-phone","logout":"logout","main-mode-flashcard-landing":"main-mode-flashcard-landing","main-mode-material":"main-mode-material","main-mode-ranking":"main-mode-ranking","write-off":"write-off","mall-paypal":"mall-paypal","password-confirm":"password-confirm","password-forget":"password-forget","password-reset":"password-reset","password-success":"password-success","plv-live-redirect":"plv-live-redirect","training-camps":"training-camps"}[chunkId]||chunkId) + "." + {"account-cancellation":"7a798c7b","achievements":"682ed116","ai~all-courses~alumni~bookmark~coupon~course~course-note-landing~dashboard~events~free-course~identi~bb685724":"f3c09a64","all-courses":"8ba59da0","alumni~course-cpnt~course-exercise~reader-book":"d15a5c89","alumni":"a871c351","chunk-4be02d47":"5f08ed44","events":"0615710b","chunk-5a28a65b":"8024f716","ai":"33eca765","bookmark":"b20d8ec0","dashboard":"fa6bd94d","free-course":"ca19235c","mini-course":"97a1995b","trail-course":"e3c3d5fb","chunk-d15b0f12":"a6bd7b37","qa-question-list":"725d9347","coupon":"1670a677","course":"655834c2","course-note-detail~course-note-landing":"175ffe05","course-note-landing":"c6aba1e0","identity":"0a82ffd5","mall-order~my-order~order-detail":"f9f44546","my-order":"edafa2ea","order-detail":"39fa5016","message":"b93b997e","must-read":"84f61fd9","points":"a7849ab4","qa-question":"e43924ee","referral":"b105718e","setting":"9534b87a","course-cpnt":"32876510","app-page":"f6b8a881","career":"0c066678","chunk-2d0d7a49":"0f8049ee","esg-registration":"1bd0f692","chunk-33f50b83":"1e3b8787","activity-transcript~mall-order~plv-live-login":"3a514ebc","activity-transcript":"13ff9a71","mall-order~write-off":"19dc061e","mall-order":"2cb11205","plv-live-login":"53452360","book~course-exercise~reader-book~training-camp":"784a49f1","course-exercise":"d34c593c","main-mode-events":"a2907e96","Pure-Mode-book":"6cc7777e","reader-book":"2136805d","book~training-camp":"dcf0e2d1","book":"8c4c590c","training-camp":"94a7cf61","course-live-mode":"6b7e85be","free-book":"93bdf820","main-mode-favorite":"d14fed4b","mini-book":"629b1ce2","trail-book":"438f7fb0","course-challenge-mode":"611384f8","course-note-detail":"7426649f","course-video-mode":"c7a936b6","esg-order-complete":"0d8c86b1","event-redirect":"8bb51758","flash-card-detail":"aae45023","flash-card-landing":"c237bdeb","home":"027a64b8","im-team-announcement":"9d4415cc","login":"0c862212","login-kecuhui":"6cb2a872","login-phone":"3fb47ebd","logout":"816831cb","main-mode-flashcard-landing":"01c4fe45","main-mode-material":"d1617601","main-mode-ranking":"6dae35fd","write-off":"92b34ec2","mall-paypal":"eff2443a","password-confirm":"c83ec0f5","password-forget":"9c2d4c25","password-reset":"07988814","password-success":"c61270bc","plv-live-redirect":"cbc2b51f","training-camps":"bde5b853","chunk-483ae6d6":"33a5ef20","chunk-719d1e60":"1e4695ef","chunk-f7037a94":"ad57ee81","chunk-640a3676":"18a034a0","chunk-018bd3e7":"54c8feed","chunk-d320aa48":"30e02fe5","chunk-c42b5490":"4aba972f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ai~all-courses~alumni~bookmark~coupon~course~course-note-landing~dashboard~events~free-course~identi~bb685724":1,"all-courses":1,"alumni":1,"chunk-4be02d47":1,"chunk-5a28a65b":1,"ai":1,"dashboard":1,"free-course":1,"trail-course":1,"qa-question-list":1,"course":1,"course-note-detail~course-note-landing":1,"identity":1,"message":1,"must-read":1,"points":1,"qa-question":1,"referral":1,"setting":1,"career":1,"esg-registration":1,"activity-transcript":1,"mall-order":1,"plv-live-login":1,"book~course-exercise~reader-book~training-camp":1,"course-exercise":1,"Pure-Mode-book":1,"reader-book":1,"book~training-camp":1,"book":1,"training-camp":1,"course-live-mode":1,"free-book":1,"mini-book":1,"trail-book":1,"course-note-detail":1,"course-video-mode":1,"esg-order-complete":1,"flash-card-detail":1,"flash-card-landing":1,"im-team-announcement":1,"login":1,"login-kecuhui":1,"login-phone":1,"main-mode-ranking":1,"write-off":1,"training-camps":1,"chunk-719d1e60":1,"chunk-f7037a94":1,"chunk-c42b5490":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account-cancellation":"account-cancellation","achievements":"achievements","ai~all-courses~alumni~bookmark~coupon~course~course-note-landing~dashboard~events~free-course~identi~bb685724":"ai~all-courses~alumni~bookmark~coupon~course~course-note-landing~dashboard~events~free-course~identi~bb685724","all-courses":"all-courses","alumni~course-cpnt~course-exercise~reader-book":"alumni~course-cpnt~course-exercise~reader-book","alumni":"alumni","events":"events","ai":"ai","bookmark":"bookmark","dashboard":"dashboard","free-course":"free-course","mini-course":"mini-course","trail-course":"trail-course","qa-question-list":"qa-question-list","coupon":"coupon","course":"course","course-note-detail~course-note-landing":"course-note-detail~course-note-landing","course-note-landing":"course-note-landing","identity":"identity","mall-order~my-order~order-detail":"mall-order~my-order~order-detail","my-order":"my-order","order-detail":"order-detail","message":"message","must-read":"must-read","points":"points","qa-question":"qa-question","referral":"referral","setting":"setting","course-cpnt":"course-cpnt","app-page":"app-page","career":"career","esg-registration":"esg-registration","activity-transcript~mall-order~plv-live-login":"activity-transcript~mall-order~plv-live-login","activity-transcript":"activity-transcript","mall-order~write-off":"mall-order~write-off","mall-order":"mall-order","plv-live-login":"plv-live-login","book~course-exercise~reader-book~training-camp":"book~course-exercise~reader-book~training-camp","course-exercise":"course-exercise","main-mode-events":"main-mode-events","Pure-Mode-book":"Pure-Mode-book","reader-book":"reader-book","book~training-camp":"book~training-camp","book":"book","training-camp":"training-camp","course-live-mode":"course-live-mode","free-book":"free-book","main-mode-favorite":"main-mode-favorite","mini-book":"mini-book","trail-book":"trail-book","course-challenge-mode":"course-challenge-mode","course-note-detail":"course-note-detail","course-video-mode":"course-video-mode","esg-order-complete":"esg-order-complete","event-redirect":"event-redirect","flash-card-detail":"flash-card-detail","flash-card-landing":"flash-card-landing","home":"home","im-team-announcement":"im-team-announcement","login":"login","login-kecuhui":"login-kecuhui","login-phone":"login-phone","logout":"logout","main-mode-flashcard-landing":"main-mode-flashcard-landing","main-mode-material":"main-mode-material","main-mode-ranking":"main-mode-ranking","write-off":"write-off","mall-paypal":"mall-paypal","password-confirm":"password-confirm","password-forget":"password-forget","password-reset":"password-reset","password-success":"password-success","plv-live-redirect":"plv-live-redirect","training-camps":"training-camps"}[chunkId]||chunkId) + "." + {"account-cancellation":"31d6cfe0","achievements":"31d6cfe0","ai~all-courses~alumni~bookmark~coupon~course~course-note-landing~dashboard~events~free-course~identi~bb685724":"4444a574","all-courses":"8ad14505","alumni~course-cpnt~course-exercise~reader-book":"31d6cfe0","alumni":"a81853b0","chunk-4be02d47":"45cf85ae","events":"31d6cfe0","chunk-5a28a65b":"18c7ed60","ai":"0e433876","bookmark":"31d6cfe0","dashboard":"d2850be7","free-course":"83ef4585","mini-course":"31d6cfe0","trail-course":"18f40c07","chunk-d15b0f12":"31d6cfe0","qa-question-list":"ff717fe2","coupon":"31d6cfe0","course":"a53d35be","course-note-detail~course-note-landing":"7b2f973d","course-note-landing":"31d6cfe0","identity":"322bbe84","mall-order~my-order~order-detail":"31d6cfe0","my-order":"31d6cfe0","order-detail":"31d6cfe0","message":"da7e63df","must-read":"bfe50bec","points":"ea61a6d9","qa-question":"842a619c","referral":"653ae514","setting":"d15158d5","course-cpnt":"31d6cfe0","app-page":"31d6cfe0","career":"b038aeae","chunk-2d0d7a49":"31d6cfe0","esg-registration":"b15170f2","chunk-33f50b83":"31d6cfe0","activity-transcript~mall-order~plv-live-login":"31d6cfe0","activity-transcript":"cc0ac801","mall-order~write-off":"31d6cfe0","mall-order":"3085ed6c","plv-live-login":"b5995776","book~course-exercise~reader-book~training-camp":"f5075d1b","course-exercise":"0ae8af44","main-mode-events":"31d6cfe0","Pure-Mode-book":"bb1f1b01","reader-book":"0ae8af44","book~training-camp":"374c6a44","book":"bad782c1","training-camp":"ed34e0a7","course-live-mode":"5e787ac3","free-book":"340428fd","main-mode-favorite":"31d6cfe0","mini-book":"5e787ac3","trail-book":"fc4dc315","course-challenge-mode":"31d6cfe0","course-note-detail":"a1227e48","course-video-mode":"da7c0ec2","esg-order-complete":"ba423792","event-redirect":"31d6cfe0","flash-card-detail":"4dec6829","flash-card-landing":"aed4afe9","home":"31d6cfe0","im-team-announcement":"2511a8a4","login":"76fd6db4","login-kecuhui":"bc2f09b7","login-phone":"be3d4995","logout":"31d6cfe0","main-mode-flashcard-landing":"31d6cfe0","main-mode-material":"31d6cfe0","main-mode-ranking":"b96e4b16","write-off":"6572dbcd","mall-paypal":"31d6cfe0","password-confirm":"31d6cfe0","password-forget":"31d6cfe0","password-reset":"31d6cfe0","password-success":"31d6cfe0","plv-live-redirect":"31d6cfe0","training-camps":"aed4afe9","chunk-483ae6d6":"31d6cfe0","chunk-719d1e60":"81fef90a","chunk-f7037a94":"fec57b95","chunk-640a3676":"31d6cfe0","chunk-018bd3e7":"31d6cfe0","chunk-d320aa48":"31d6cfe0","chunk-c42b5490":"9c6b2ace"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"setting": [
 				"chunk-2d0d7a49",
 				"chunk-c42b5490"
 			],
 			"mall-order": [
 				"chunk-2d0d7a49",
 				"chunk-c42b5490"
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
